import { useStepValidation } from '../../hooks';

export const useProfessionalExperienceNavigation = () => {
  const { handleStepNavigation } = useStepValidation('PROFESSIONAL_EXPERIENCE');

  const handleBeforeNavigate = () => {
    // Professional experience is optional - always allow navigation
    return true;
  };

  return {
    handleBeforeNavigate,
    handleStepNavigation
  };
};
